function AnalysisControls() {
    "use strict";
    this.AnalysisDetailsMap = null;
    this.CardView = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;
    this.Map = null;
    this.MapLocate = null;
    this.IncidentMap = null;
    this.IncidentMapLocate = null;
    this.Validator = null;
    this.MatchesCardView = null;
    this.PlaybackControl = null;
    this.NotificationPanel = null;
}
if (typeof exports !== 'undefined') {
    module.exports = AnalysisControls;
}